import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import template from './view-full-game-inventory-widget.html';

/* Redux */
const mapStateToThis = ({ session }) => ({
  retailer: session.retailer,
});

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class ViewFullGameInventoryWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.retailerNo = this.$state.params.retailerNo || this.retailer.retailerId;
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class ViewFullGameInventoryWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = ViewFullGameInventoryWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/view-full-game-inventory/view-full-game-inventory-widget-component.js